import { Feature } from 'ol';
import { Vector as VectorLayer } from 'ol/layer';
import { Vector as VectorSource } from 'ol/source';
import { Omrade } from '@/domain/omrader';
import { WKTObject } from '@/domain/WKTObject';
import { wktObjectToFeature } from '@/utils/SpatialHelper';
import { getAreaOutlineStyle } from '../style/OmraderStyle';
import { FeatureLayerType } from './FeatureLayerType';
import React from 'react';
import { MapContext } from '@/state/context/MapContext';
import { defaultColor } from '@/utils/ColorHelper';
import { Geometry } from 'ol/geom';

interface Props {
    area: Omrade;
    areaGeometry: WKTObject;
    zoom: number;
    isNiBLayer: boolean;
}

export class OmraderFeatureLayer extends React.Component<Props> {
    static contextType = MapContext;
    declare context: React.ContextType<typeof MapContext>;

    static IsAreaFeatureKey = 'IS_AREA_FEATURE';

    private layer!: VectorLayer<VectorSource<Feature<Geometry>>>;
    private areaFeature!: Feature<Geometry>;

    componentDidMount() {
        this.areaFeature = this.createAreaFeature();
        const features = [this.areaFeature];
        this.layer = new VectorLayer({
            source: new VectorSource({
                features,
            }),
            style: getAreaOutlineStyle(this.props.isNiBLayer, this.props.zoom),
            zIndex: 1,
        });

        this.context.map.addLayer(this.layer);
    }

    componentDidUpdate(prevProps: Props) {
        if (
            prevProps.isNiBLayer !== this.props.isNiBLayer ||
            prevProps.zoom !== this.props.zoom
        ) {
            const style = getAreaOutlineStyle(this.props.isNiBLayer, this.props.zoom);
            this.layer.setStyle(style);
        }

        if (prevProps.areaGeometry?.wkt !== this.props.areaGeometry?.wkt) {
            this.areaFeature = this.createAreaFeature();
            const source = this.layer.getSource();
            source?.clear();
            source?.addFeature(this.areaFeature);
        }
    }

    componentWillUnmount() {
        this.context.map.removeLayer(this.layer);
    }

    render() {
        return null;
    }

    private createAreaFeature(): Feature<Geometry> {
        const { area, areaGeometry } = this.props;
        const featureTypeId = area.vegobjekt?.metadata?.type.id;
        if (featureTypeId == null) {
            throw new Error(`Område ${area.navn} mangler vegobjekttype`);
        }

        const feature = wktObjectToFeature(
            areaGeometry.wkt,
            `area-${area.nummer}`,
            featureTypeId,
            FeatureLayerType.AREA_OUTLINE,
            defaultColor
        );
        feature.set(OmraderFeatureLayer.IsAreaFeatureKey, true);
        return feature;
    }
}
